import { render, staticRenderFns } from "./dialog-detailinbox.vue?vue&type=template&id=dec56410&"
import script from "./dialog-detailinbox.vue?vue&type=script&lang=js&"
export * from "./dialog-detailinbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports